class AppHelper {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static isInApk() {
    return document.referrer === 'android-app://cl.autofact.portalclientes.app/';
  }
}

export default AppHelper;
